var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarketDepth = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.292 3.795 4 6.085V0H3v6.086L.709 3.795l-.707.707L3.501 8l3.498-3.498z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 9h7v3H0zm1 1h5v1H1z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m12 1.914 2.292 2.291.707-.707L11.5 0 8.002 3.498l.707.707 2.292-2.29V8h1z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 13h7v3H2a2 2 0 0 1-2-2zm1 1h5v1H2a1 1 0 0 1-1-1m14-1v1a2 2 0 0 1-2 2H8v-3zm-6 1h5a1 1 0 0 1-1 1H9zM8 9h7v3H8zm1 1h5v1H9z",
  clipRule: "evenodd"
})));
export default SvgMarketDepth;